module.exports = __webpack_public_path__ + "img/840.3c3e599e.svg";